import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export function useListenElementOffsetWidth(ref: RefObject<HTMLDivElement>) {
  const [offsetWidth, setOffsetWidth] = useState(0);

  useEffect(() => {
    const refValue = ref.current;

    if (!refValue) return;

    const setCallback = () => {
      setOffsetWidth(refValue.offsetWidth);
    };

    setCallback();

    window.addEventListener('resize', setCallback);

    return () => {
      window.removeEventListener('resize', setCallback);
    };
  });

  return offsetWidth;
}
